<div class="card h-100 min-vh-79">
  <div class="card-body flex-none row">

    <div class="my-plan-header-mb col-md-12 d-flex pb-4 align-items-center"
      [class]="isMyPlanSelected ? 'justify-content-end' : 'justify-content-between'"
    >
      <ng-container *ngIf="!isMyPlanSelected">
        <app-quiz-binary-toggle
          [leftLabel]="'Monthly'"
          [rightLabel]="'Annually'"
          [(isLeftSelected)]="isMonthlySelected"
        ></app-quiz-binary-toggle>
      </ng-container>

      <app-quiz-button-toggle-group
        [(selectedIndex)]="selectedIndex"
        [leftLabel]="'My Plan'"
        [rightLabel]="'All Subscription'"
      ></app-quiz-button-toggle-group>
    </div>

    <ng-container [ngTemplateOutlet]="isMyPlanSelected ? myPlan : allSubscriptions"></ng-container>
  </div>
</div>

<ng-template #myPlan>
  <div class="col-md-6 min-vh-65 mb-mobile-4">
    <app-profile-subscription-card class="h-100" [isMyPlan]="true"></app-profile-subscription-card>
  </div>
  <div class="col-md-6">
    <div class="border rounded-2 pt-5 p-4 shadow-sm w-100 min-vh-65">
      <div class="subscription-title-color">
        <span class="fw-medium fs-3">Your plan includes</span>
      </div>

      <br>
      <br>

      <div class="d-flex flex-column gap-2">
        <div class="d-flex flex-row gap-3 align-items-center">
          <mat-icon class="text-primary">check</mat-icon>
          <span class="fs-4 text-gray">Plan Feature</span>
        </div>
        <div class="d-flex flex-row gap-3 align-items-center">
          <mat-icon class="text-primary">check</mat-icon>
          <span class="fs-4 text-gray">Plan Feature</span>
        </div>
        <div class="d-flex flex-row gap-3 align-items-center">
          <mat-icon class="text-gray">close</mat-icon>
          <span class="fs-4 text-gray">Plan Feature</span>
        </div>
        <div class="d-flex flex-row gap-3 align-items-center">
          <mat-icon class="text-gray">close</mat-icon>
          <span class="fs-4 text-gray">Plan Feature</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #allSubscriptions>
  <div
    *ngFor="let subscription of subscriptions"
    class="pb-9"
    [class]="getClassesBySubscriptionsCount()"
  >
    <app-profile-subscription-card
      [ngClass]="{'w-100': subscriptionsCount >= 4}"
      [isMyPlan]="false"
    ></app-profile-subscription-card>
  </div>
</ng-template>
